import React, {useEffect, useState} from "react";

import { useNavigate } from "react-router-dom";

import { Dropdown, Button } from "react-bootstrap";
import { useAuth } from "../../../auth/AuthProvider";
import SearchBox from "./SearchBox";

const Header = ({ onNote, toggle, onProfile, onNotification, onClick }) => {

  const [sessionData, setSessionData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const navigate = useNavigate();
    const auth = useAuth();
    const {getUserName} = auth

    const logOut = () =>{
      auth.logOut();
      navigate('/login');
    }


  useEffect(() => {
    const user_name_getted = getUserName();
    if (user_name_getted) {
      console.log(user_name_getted)
      setSessionData(user_name_getted);
    }
  }, [getUserName]);

  useEffect(() => {
    const wrapper = document.querySelector("#main-wrapper");
    if (!wrapper) return;

    const checkSidebarState = () => {
      const isMobile = window.innerWidth <= 768;
      const isOpen = isMobile 
        ? wrapper.classList.contains("menu-toggle") 
        : !wrapper.classList.contains("menu-toggle");
      setIsSidebarOpen(isOpen);
    };

    checkSidebarState();
    
    window.addEventListener("resize", checkSidebarState);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          checkSidebarState();
        }
      });
    });

    observer.observe(wrapper, { attributes: true });
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", checkSidebarState);
    };
  }, []);

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left d-flex align-items-center">
              {!isSidebarOpen && (
                <div
                  className="dashboard_bar text-white d-none d-md-block"
                  style={{ textTransform: "capitalize", margin: 0 }}
                >
                  OTT Manager
                </div>
              )}
            </div>

            <ul className="navbar-nav header-right">
              <li className="nav-item d-none d-md-flex">
                  <SearchBox />
              </li>

              <Dropdown className="nav-item dropdown header-profile ml-sm-4 ml-2">
                <Dropdown.Toggle
                  as="a"
                  to="#"
                  variant=""
                  className="nav-link i-false c-pointer"
                >
                  <div className="header-info">
                    <span className="text-white">
                      <strong>Wellbeing360</strong>
                    </span>
                    {sessionData ? <p className="fs-12 mb-0 text-white">{sessionData}</p>
                        : <></>}
                  </div>
                  <div style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    marginLeft: '15px'
                  }}>
                    {sessionData ? sessionData.charAt(0).toUpperCase() : 'W'}
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-3 border-0 shadow-sm" style={{ borderRadius: '12px', minWidth: '180px', padding: '5px' }}>
                    <Button 
                        variant="" 
                        className='dropdown-item ai-icon d-flex align-items-center' 
                        onClick={()=> logOut()}
                        style={{ borderRadius: '8px', padding: '10px 15px', transition: 'all 0.2s' }}
                    >
                        <svg
                          id="icon-logout"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ color: '#8743DF' }}
                          width={18}
                          height={18}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                          <polyline points="16 17 21 12 16 7" />
                          <line x1={21} y1={12} x2={9} y2={12} />
                        </svg>
                        <span className="ml-3 font-w500" style={{ color: '#8743DF' }}>Cerrar sesión </span>
                    </Button>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
